export const FETCH_SURVEY_DETAILS_IN_REPONSE='FETCH_SURVEY_DETAILS_IN_REPONSE';
export const STORE_POST_OBJECT_DATE_STRING='STORE_POST_OBJECT_DATE_STRING';
export const ON_CHANGE_DATE_PICKER='ON_CHANGE_DATE_PICKER'